import { render, staticRenderFns } from "./TalleresCalidadPremiumBeneficios.vue?vue&type=template&id=441a77cb&scoped=true&"
import script from "./TalleresCalidadPremiumBeneficios.vue?vue&type=script&lang=js&"
export * from "./TalleresCalidadPremiumBeneficios.vue?vue&type=script&lang=js&"
import style0 from "./TalleresCalidadPremiumBeneficios.vue?vue&type=style&index=0&id=441a77cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "441a77cb",
  null
  
)

export default component.exports